<template>
  <div class="form-container ou-donation-form rtl" dir="rtl">
      <div class="holder">
          <PaymentForm class="form-horizontal">
              <FormSection title="אשמח לתרום">
                  <FormRow inline>
                    <LazyCurrencySelector :currencies="['USD', 'ILS']"/>
                  </FormRow>
                  <FormRow> 
                    <OuisraelZecherLmachatzitHashekelAmounts/>                    
                    <ErrorLabel field="amount" />
                  </FormRow>
              </FormSection>
              <FormSection title="פרטים אישיים">
                  <FormRow inline>
                      <FormCol field="title" :flex="1" lang="he"/>
                      <FormCol field="firstName" :flex="2" />
                      <FormCol field="lastName" :flex="2" />
                  </FormRow>
                  <FormRow inline>
                      <FormCol field="email" />
                      <FormCol field="phone" />
                  </FormRow>
                  <FormRow inline>
                      <Consent privacy="https://www.ouisrael.org/privacy-policy/" lang="heb"/>
                  </FormRow>                   
              </FormSection>
              <FormSection title="כתובת" last>
                  <DonorAddress lang="he"/>
              </FormSection>
              <FormSection title="פרטי תשלום" last>
                  <FormRow>
                    <Receipt />
                  </FormRow>
                    <FormRow inline>
                    <FormCol field="card" :showLabel="false" lang="he"/>
                    </FormRow>
                </FormSection>
              <PaymentButton showAmount btnText="המשך לתרומה"/>
          </PaymentForm>
      </div>
  </div>
</template>
<style scoped lang="scss">
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.fee-total {
  margin-bottom: 0;
  justify-content: space-between;
}
.other-means {
  font-size: 14px;
  line-height: 1.6;
}

::v-deep  .form-container.ou-donation-form.rtl input[type=radio] {
    margin-left: 4px;
}
</style>

